import { createAction, props } from '@ngrx/store';

export const setInitialState = createAction('[Initial State] Set', 
    props<{
        initialState: any
    }>());

    